var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.user.clientID)?_c('div',{key:_vm.$root.time},[_c('h1',{staticClass:"main-heading"},[_vm._v("Industry & Agriculture")]),_c('SectionNavigator',{attrs:{"sections":_vm.$root.industryAndAgriculture.sections,"schemas":_vm.$root.industryAndAgriculture.schemas}}),_c('router-view')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }